import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import EditIcon from "@mui/icons-material/Edit";
import request from "../../../Helpers/API";
import { AgregarLineaModal } from "./AgregarLineaModal";
import EditarLineaModal from "./EditarLineaModal";

export const LineasListadoScreen = () => {
  const history = useHistory();
  const { state } = useLocation();
  const [lineas, setLineas] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalEditar, setOpenModalEditar] = useState(false);
  const [selectedID, setSelectedID] = useState();

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenModalEditar = (id) => {
    setSelectedID(id);
    setOpenModalEditar(true);
  };

  const handleCloseModalEditar = () => {
    setSelectedID(null);
    setOpenModalEditar(false);
  };

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ListadoLineasVenta/Lineas`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setLineas(result);
        return;
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        return;
      });
    setLoader({ ...loader, mostrar: false });
  }, [openModal, openModalEditar]);

  return (
    <PlantillaScreen
      titulo={`LINEAS DE VENTA`}
      className={"lineas-venta-main-screen"}
      className_main={1}
    >
      <div className="lineas-venta-actions">
        <div
          className="lineas-venta-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="buttons">
          <button
            className="lineas-venta-header-agregar-linea"
            onClick={() => handleOpenModal()}
          >
            <AddCircleOutlineIcon /> Agregar
          </button>
        </div>
      </div>
      <div className="lineas-venta">
        <LoaderScreen loader={loader} />
        <div className="lineas-venta-header">
          <div className="lineas-venta-header-title">
            <FormatListNumberedIcon /> Listado de Lineas Registradas
          </div>
        </div>
        <div className="lineas-venta-container scroll-4">
          <table>
            <thead>
              <tr>
                <th>Departamento</th>
                <th>
                  <div>Descripción</div>
                </th>
                <th>
                  <div>Estatus</div>
                </th>

                <th>
                  <div>Editar</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {lineas.map((li) => (
                <tr key={li.idlinea}>
                  <td>{li.departamento}</td>
                  <td className="ta-descripcion">{li.descripcion}</td>
                  <td className="ta-estatus">
                    {li.estatus === 0 ? (
                      <RemoveCircleIcon sx={{ color: "#7b7b7b" }} />
                    ) : (
                      <CheckCircleIcon sx={{ color: "#5aa05b" }} />
                    )}
                  </td>

                  <td className="ta-editar">
                    <div className="lineas-venta-acciones-listado">
                      <div
                        className="boton-editar-lineas-venta"
                        onClick={() => handleOpenModalEditar(li.idlinea)}
                      >
                        <EditIcon /> Editar
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <AgregarLineaModal
          open={openModal}
          onClose={handleCloseModal}
          //   folio={folio}
        />
        <EditarLineaModal
          open={openModalEditar}
          onClose={handleCloseModalEditar}
          id={selectedID}
        />
      </div>
    </PlantillaScreen>
  );
};
